<template>
    <uw-page title="申请单">
        <template slot="header-suffix">
            <files-prints-xls-dropdown model="ims_product_order" state=0 :id="id" :style="{ float: 'right', marginLeft: '5px' }" />
            <el-button type="primary" @click="$refs.applyCreateProduct.Open({ product_order_id: id })">添加产品</el-button>
        </template>
        <vxe-table border :data="table" height="100%">
            <vxe-column min-width="200" title="供应商">
                <template #default="{ row }">
                    <el-span type="primary" @click.native="$refs.supplierDetails.Open(row.product.supplier?.id)" :title="row.product.supplier?.name" />
                </template>
            </vxe-column>
            <vxe-column min-width="120" title="产品名称">
                <template #default="{ row }">
                    <el-span type="primary" @click.native="$refs.productDetails.Open(row.product.id)" :title="row.product.name" />
                </template>
            </vxe-column>
            <vxe-column min-width="100" field="product.type.name" title="产品类别"></vxe-column>
            <vxe-column min-width="100" field="product.brand" title="产品品牌"></vxe-column>
            <vxe-column min-width="200" title="规格参数">
                <template #default="{ row }">
                    {{ row.product.parameter?.toString() }}
                </template>
            </vxe-column>
            <vxe-column min-width="80" title="采购数量">
                <template #default="{ row }">
                    {{ row.num }} / {{ row.product.unit }}
                </template>
            </vxe-column>
            <vxe-column min-width="80" title="采购单价">
                <template #default="{ row }">
                    {{ $lodash.toMoney(row.money) }}
                </template>
            </vxe-column>
            <vxe-column min-width="90" title="合计金额">
                <template #default="{ row }">
                    {{ $lodash.toMoney(row.money_total) }}
                </template>
            </vxe-column>
            <vxe-column min-width="70" field="product.maintenance" title="保修期"></vxe-column>
            <vxe-column min-width="70" field="describe" title="备注说明"></vxe-column>
            <vxe-column min-width="90" title="折扣">
                <template #default="{ row }">
                    {{ row.discount }} %
                </template>
            </vxe-column>
            <vxe-column min-width="90" title="整单折扣">
                <template #default="{ row }">
                    {{ row.discount_document }} %
                </template>
            </vxe-column>
            <vxe-column min-width="100" title="整单折后价">
                <template #default="{ row }">
                    {{ $lodash.toMoney(row.money_discount) }}
                </template>
            </vxe-column>
            <vxe-column width="80" align="center" fixed="right">
                <template #default="{ row }">
                    <el-link type="primary" :underline="false" @click="$refs.applyUpdateProduct.Open(row.id)" :style="{ marginRight: '10px' }">编辑</el-link>
                    <el-link type="danger"  :underline="false" @click="Delete(row.id)">移除</el-link>
                </template>
            </vxe-column>
        </vxe-table>
        <ims-order-apply-create-product ref="applyCreateProduct" @onChange="TableSearch" />
        <ims-order-apply-update-product ref="applyUpdateProduct" @onChange="TableSearch" />
        <ims-product-drawer ref="productDetails" @onChange="TableSearch" />
        <ims-supplier-drawer ref="supplierDetails" @onChange="TableSearch" />
    </uw-page>
</template>
<script>
export default {
    props: {
        id: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            table: []
        }
    },
    watch: {
        id: {
            handler(val) {
                this.TableSearch()
            },
            immediate: true
        }
    },
    methods: {
        TableSearch() {
            this.$http.post(
                '/9api/ims/product-order-log/search-all',
                {
                    search: { product_order_id: this.id, state: 0 },
                    append: ['product', 'pay_type']
                }
            ).then(rps => {
                this.table = rps.data
                this.$emit('onChange')
            })
        },
        Delete(id) {
            this.$http.post('/9api/ims/product-order-log/delete', { id: id }).then(rps => {
                this.TableSearch()
            })
        }
    }
}
</script>